import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

// Pages
import LoginPage from "../pages/LoginPage";
import DashboardPage from "../pages/DashboardPage";
import MainLayout from "../components/layout/MainLayout";
import ProtectedRoute from "./ProtectedRoute";

import CustomersListPage from "../pages/customers/CustomersListPage";
import CustomerViewPage from "../pages/customers/CustomerViewPage";
import CustomerEditPage from "../pages/customers/CustomerEditPage";
import CustomerCreatePage from "../pages/customers/CustomerCreatePage";

import UserListPage from "../pages/users/UserListPage";
import UserCreatePage from "../pages/users/UserCreatePage";
import UserEditPage from "../pages/users/UserEditPage";

import DevicesListPage from "../pages/devices/DevicesListPage";
import DeviceViewPage from "../pages/devices/DeviceViewPage";
import DeviceEditPage from "../pages/devices/DeviceEditPage";
import DeviceCreatePage from "../pages/devices/DeviceCreatePage";

import PaymentsListPage from "../pages/payments/PaymentsListPage";
import SalesListPage from "../pages/sales/SalesListPage";
import NotificationsListPage from "../pages/notifications/NotificationsListPage";

import AgentsPage from "../pages/agents/AgentsPage";
import AdminAgentManagementPage from "../pages/agents/AdminAgentManagementPage";

import RoleManagementPage from "../pages/RoleManagementPage";
import RoleAssignmentPage from "../pages/RoleAssignmentPage";

import CustomerBalancesPage from "../pages/balances/CustomerBalancesPage";
import RefundsPage from "../pages/refunds/RefundsPage";

// Unauthorized fallback page
const UnauthorizedPage = () => (
  <div style={{ textAlign: "center", marginTop: "60px" }}>
    <h2>🚫 Access Denied</h2>
    <p>You do not have permission to view this page.</p>
  </div>
);

function AppRoutes() {
  return (
    <Routes>
      {/* Public Route */}
      <Route path="/login" element={<LoginPage />} />

      {/* Main Layout Routes */}
      <Route element={<MainLayout />}>
        {/* Default redirect */}
        <Route path="/" element={<Navigate to="/dashboard" replace />} />

        {/* Dashboard (all roles allowed) */}
        <Route path="/dashboard" element={<DashboardPage />} />

        {/* Customers (Admin, Manager, Agent) */}
        <Route element={<ProtectedRoute allowedRoles={["admin","manager","agent"]} />}>
          <Route path="/customers" element={<CustomersListPage />} />
          <Route path="/customers/create" element={<CustomerCreatePage />} />
          <Route path="/customers/view/:customerId" element={<CustomerViewPage />} />
          <Route path="/customers/edit/:customerId" element={<CustomerEditPage />} />
        </Route>

        {/* Users (Admin only) */}
        <Route element={<ProtectedRoute allowedRoles={["admin"]} />}>
          <Route path="/users" element={<UserListPage />} />
          <Route path="/users/create" element={<UserCreatePage />} />
          <Route path="/users/edit/:userId" element={<UserEditPage />} />
        </Route>

        {/* Devices (Admin, Stock Controller) */}
        <Route element={<ProtectedRoute allowedRoles={["admin","stock controller"]} />}>
          <Route path="/devices" element={<DevicesListPage />} />
          <Route path="/devices/view/:deviceId" element={<DeviceViewPage />} />
          <Route path="/devices/edit/:deviceId" element={<DeviceEditPage />} />
          <Route path="/devices/create" element={<DeviceCreatePage />} />
        </Route>

        {/* Sales & Payments (Admin, Manager) */}
        <Route element={<ProtectedRoute allowedRoles={["admin","manager"]} />}>
          <Route path="/sales" element={<SalesListPage />} />
          <Route path="/payments" element={<PaymentsListPage />} />
        </Route>

        {/* Balances & Refunds (Admin, Manager, Agent) */}
        <Route element={<ProtectedRoute allowedRoles={["admin","manager","agent"]} />}>
          <Route path="/balances" element={<CustomerBalancesPage />} />
          <Route path="/refunds" element={<RefundsPage />} />
        </Route>

        {/* Notifications */}
        <Route element={<ProtectedRoute allowedRoles={["admin","manager","agent","call center"]} />}>
          <Route path="/notifications" element={<NotificationsListPage />} />
        </Route>

        {/* Agent Management */}
        <Route element={<ProtectedRoute allowedRoles={["admin","manager"]} />}>
          <Route path="/agents" element={<AgentsPage />} />
          <Route path="/agents/manage" element={<AdminAgentManagementPage />} />
        </Route>

        {/* Role Management (Admin only) */}
        <Route element={<ProtectedRoute allowedRoles={["admin"]} />}>
          <Route path="/role-management" element={<RoleManagementPage />} />
          <Route path="/role-assignment" element={<RoleAssignmentPage />} />
        </Route>

        {/* Unauthorized */}
        <Route path="/unauthorized" element={<UnauthorizedPage />} />
      </Route>

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}

export default AppRoutes;
